import BaseCommand from "@/models/api/commands/BaseCommand";

export class OrderItemMoveDownCommand extends BaseCommand {
  CommandName = "OrderItemMoveDown";
  Command: string;
  constructor(sessionId: string, operationId: string, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = orderItemId;
  }
}
